@if ((current | documentFileSizeUsedToPercentage: total); as percentage) {
  @if (percentage > fileUploadThreshold) {
    <div class="progress progress-height">
      <div class="progress-bar" [style.width.%]="percentage"
        role="progressbar" aria-valuenow="{{percentage}}" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>
    <p class="color-font-gray font-size-11">{{current | number:'1.2-2':'de-CH'}} MB
      <ng-container i18n="@@app.of">of</ng-container> {{total}} MB</p>
    }
  }
